import { gql } from 'urql';

export const GET_ACCOUNT_ENTITLEMENTS = gql`
  query GetAccountEntitlement($filter: String) {
    accountEntitlements(filter: $filter) {
      name
      label
      allowedUnits
      usedUnits
    }
  }
`;

export const GET_TARGETING_OPTIONS = gql`
  query GetTargetingOptions {
    accountDomains {
      id
      domain
    }
    banners: experiences(filter: { types: [BANNER] }) {
      id
      name
      steps {
        id
      }
    }
    embeds: experiences(filter: { types: [EMBED] }) {
      id
      name
      steps {
        id
      }
    }
    checklists(filter: { states: [DRAFT] }) {
      id
      internalName
    }
    emails {
      id
      name
    }
    eventNames(filter: { showInUi: true }) {
      name
      showInUi
    }
    flows(filter: { states: [DRAFT] }) {
      id
      name
      steps {
        stepType
        id
        index
      }
    }
    mobile: experiences(filter: { types: [MOBILE, MOBILE_EMBED] }) {
      id
      name
    }
    pins: experiences(filter: { types: [PERSISTENT] }) {
      id
      name
      steps {
        id
      }
    }
    profileAttributes(filter: { showInUi: true }) {
      name
      label
      showInUi
    }
    pushNotifications {
      id
      name
      content
    }
    segments {
      id
      name
    }
  }
`;

export const GET_ACCOUNT_IDENTIFIERS = gql`
  query getAccountIdentifiers {
    account {
      accountIdentifiers {
        accountIdentifier
        emailProperty
        userIdentifier
      }
    }
  }
`;
